import script from "./FormNestedItemsField.vue?vue&type=script&setup=true&lang=js"
export * from "./FormNestedItemsField.vue?vue&type=script&setup=true&lang=js"

import "./FormNestedItemsField.vue?vue&type=style&index=0&id=28556a5e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28556a5e"]])

export default __exports__